import PropTypes from "prop-types";
import React, { useState } from "react";
//import { useForm } from 'react-hook-form';
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../styles/scss/popup.css";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CancelSharpIcon from "@material-ui/icons/CancelSharp";
import ImgCheck from "../../../images/icons8-checked.svg";
import { useRef } from "react";
import validator from "../../common/validator";
import shortid from "shortid";

const PropsType = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onComfirm: PropTypes.func,
};

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#0ec1fe",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#00b5e8",
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: "10px 0 0",
    },
  },
}));

const CardEdu = (props) => {
  const {
    item,
    index,
    education,
    addEducation,
    deleteEducation,
    setspecialistInfo,
  } = props;
  const [credenrial, setCredenrial] = useState({ value: "", isValid: false });
  const [institution, setInstitution] = useState({ value: "", isValid: false });

  return (
    <Row className='modalSpecialist__row'>
      <Col md={6}>
        <CssTextField
          label='Credentials'
          helperText='Enter professional degrees, diplomas or certifications'
          id='credenrials'
          name='credenrials'
          value={credenrial.value}
          onChange={(e) => {
            const dataCre = { ...credenrial, value: e.target.value };
            const dataIns = { ...institution };
            const itemCheck = { ...item };
            const eduData = [...education];
            if (
              !validator.isValid(dataCre.value) ||
              !validator.isValid(dataIns.value)
            ) {
              dataCre.isValid = false;
              setCredenrial(dataCre);
              itemCheck.isValid = false;
            } else if (
              validator.isValid(dataCre.value) &&
              validator.isValid(dataIns.value)
            ) {
              dataCre.isValid = true;
              dataIns.isValid = true;
              setCredenrial(dataCre);
              setInstitution(dataIns);
              itemCheck.isValid = true;
            } else {
              dataCre.isValid = true;
              setCredenrial(dataCre);
              itemCheck.isValid = false;
            }
            setCredenrial(dataCre);
            eduData[eduData.findIndex((el) => el._id === item._id)] = itemCheck;
            setspecialistInfo(() => ({
              education: eduData,
            }));
          }}
          fullWidth
          margin='normal'
          InputLabelProps={{
            shrink: true,
          }}
        />
        {!credenrial.isValid && (
          <span className='help-block'>Credenrial is require</span>
        )}
      </Col>
      <Col md={6}>
        <CssTextField
          label='Educational Institution'
          helperText='Enter educational institution where degree was awarded'
          id='country'
          name='country'
          fullWidth
          value={institution.value}
          onChange={(e) => {
            const dataCre = { ...credenrial };
            const dataIns = { ...institution, value: e.target.value };
            const itemCheck = { ...item };
            const eduData = [...education];
            if (
              !validator.isValid(dataCre.value) ||
              !validator.isValid(dataIns.value)
            ) {
              dataIns.isValid = false;
              setInstitution(dataIns);
              itemCheck.isValid = false;
            } else if (
              validator.isValid(dataCre.value) &&
              validator.isValid(dataIns.value)
            ) {
              dataCre.isValid = true;
              dataIns.isValid = true;
              setCredenrial(dataCre);
              setInstitution(dataIns);
              itemCheck.isValid = true;
            } else {
              dataIns.isValid = true;
              setInstitution(dataIns);
              itemCheck.isValid = false;
            }
            setInstitution(dataIns);
            eduData[eduData.findIndex((el) => el._id === item._id)] = itemCheck;
            setspecialistInfo(() => ({
              education: eduData,
            }));
          }}
          margin='normal'
          InputLabelProps={{
            shrink: true,
          }}
        />
        {!institution.isValid && (
          <span className='help-block'>Institution is require</span>
        )}
      </Col>
      <button onClick={addEducation} className='modalSpecialist__btnrow btn'>
        <AddCircleOutlineIcon style={{ fill: "#0ec1fe" }} />
      </button>
      {education.length > 1 && (
        <button
          onClick={() => deleteEducation(index)}
          className='modalSpecialist__btndelete btn'
        >
          <CancelSharpIcon style={{ fill: "#b7b7b7" }} />
        </button>
      )}
    </Row>
  );
};

function PopupSpecilist({ open, onClose, handleSubmit }) {
  //const { register, errors, triggerValidation, handleSubmit } = useForm();
  const [specialistInfo, setspecialistInfo] = useState({
    education: [{ _id: shortid.generate(), isValid: false }],
  });
  let { education } = specialistInfo;
  const [fullname, setFullname] = useState({ value: "", isValid: true });
  const [gender, setGender] = useState({ value: "", isValid: true });
  const [countryCode, setCountryCode] = useState({ value: "", isValid: true });
  const [mobile, setMobile] = useState({ value: "", isValid: true });
  const [license, setLicense] = useState({ value: "", isValid: true });
  const [languages, setLanguages] = useState({ value: "", isValid: true });
  const [month, setMonth] = useState({ value: "", isValid: true });
  const [year, setYear] = useState({ value: "", isValid: true });
  const [zipCode, setZipCode] = useState({ value: "", isValid: true });
  const [countryName, setCountryName] = useState({ value: "", isValid: true });
  const [city, setCity] = useState({ value: "", isValid: true });
  const [status, setStatus] = useState({ value: "", isValid: true });
  const [address, setAddress] = useState({ value: "", isValid: true });
  const [specialization, setSpecialization] = useState({
    value: "",
    isValid: true,
  });
  const [subspecialty, setSubspecialty] = useState({
    value: "",
    isValid: true,
  });
  const [conditions, setConditions] = useState({ value: "", isValid: true });
  const classes = useStyles();
  const ref = useRef({});
  const nextSlice = (order) => {
    const fullnameC = { ...fullname };
    const genderC = { ...gender };
    const languagesC = { ...languages };
    const licenseC = { ...license };
    const monthC = { ...month };
    const yearC = { ...year };
    const countryCodeC = { ...countryCode };
    const mobileC = { ...mobile };
    const zipC = { ...zipCode };
    const countryNameC = { ...countryName };
    const cityC = { ...city };
    const statusC = { ...status };
    const addressC = { ...address };
    const spec = { ...specialization };
    const sub = { ...subspecialty };
    const cond = { ...conditions };
    let flag = true;
    switch (order) {
      case 1:
        if (!validator.isValid(fullnameC.value)) {
          fullnameC.isValid = false;
        } else {
          fullnameC.isValid = true;
        }
        if (!validator.isValid(genderC.value)) {
          genderC.isValid = false;
        } else {
          genderC.isValid = true;
        }
        if (!validator.isValid(languagesC.value)) {
          languagesC.isValid = false;
        } else {
          languagesC.isValid = true;
        }
        if (!validator.isValid(licenseC.value)) {
          licenseC.isValid = false;
        } else {
          licenseC.isValid = true;
        }
        if (!validator.isValid(monthC.value)) {
          monthC.isValid = false;
        } else {
          monthC.isValid = true;
        }
        if (!validator.isValid(yearC.value)) {
          yearC.isValid = false;
        } else {
          yearC.isValid = true;
        }
        if (!validator.isValid(countryCodeC.value)) {
          countryCodeC.isValid = false;
        } else {
          countryCodeC.isValid = true;
        }
        if (!validator.isValid(mobileC.value)) {
          mobileC.isValid = false;
        } else {
          mobileC.isValid = true;
        }
        if (
          fullnameC.isValid &&
          genderC.isValid &&
          languagesC.isValid &&
          licenseC.isValid &&
          monthC.isValid &&
          yearC.isValid &&
          countryCodeC.isValid &&
          mobileC.isValid
        ) {
          ref.current.slickNext();
        }
        setFullname(fullnameC);
        setGender(genderC);
        setLanguages(languagesC);
        setLicense(licenseC);
        setMonth(monthC);
        setYear(yearC);
        setCountryCode(countryCodeC);
        setMobile(mobileC);
        break;
      case 2:
        if (!validator.isValid(zipC.value)) {
          zipC.isValid = false;
        } else {
          zipC.isValid = true;
        }
        if (!validator.isValid(countryNameC.value)) {
          countryNameC.isValid = false;
        } else {
          countryNameC.isValid = true;
        }
        if (!validator.isValid(cityC.value)) {
          cityC.isValid = false;
        } else {
          cityC.isValid = true;
        }
        if (!validator.isValid(statusC.value)) {
          statusC.isValid = false;
        } else {
          statusC.isValid = true;
        }
        if (!validator.isValid(addressC.value)) {
          addressC.isValid = false;
        } else {
          addressC.isValid = true;
        }
        if (
          zipC.isValid &&
          countryNameC.isValid &&
          cityC.isValid &&
          statusC.isValid &&
          addressC.isValid
        ) {
          ref.current.slickNext();
        }
        setZipCode(zipC);
        setCountryName(countryNameC);
        setCity(cityC);
        setStatus(statusC);
        setAddress(addressC);
        break;
      case 3:
        for (const edu of education) {
          if (!edu.isValid) {
            flag = false;
            break;
          }
        }
        if (flag) {
          ref.current.slickNext();
        }
        break;
      case 4:
        if (!validator.isValid(spec.value)) {
          spec.isValid = false;
        } else {
          spec.isValid = true;
        }
        if (!validator.isValid(sub.value)) {
          sub.isValid = false;
        } else {
          sub.isValid = true;
        }
        if (!validator.isValid(cond.value)) {
          cond.isValid = false;
        } else {
          cond.isValid = true;
        }
        if (spec.isValid && sub.isValid && cond.isValid) {
          ref.current.slickNext();
        }
        setSpecialization(spec);
        setSubspecialty(sub);
        setConditions(cond);
        break;
      default:
        break;
    }
  };
  const addEducation = () => {
    setspecialistInfo((specialistInfo) => ({
      ...specialistInfo,
      education: [
        ...specialistInfo.education,
        { _id: shortid.generate(), isValid: false },
      ],
    }));
  };

  const deleteEducation = (index) => {
    let data = specialistInfo.education.filter(
      (item, indexItem) => indexItem !== index
    );
    setspecialistInfo((specialistInfo) => ({
      ...specialistInfo,
      education: data,
    }));
  };

  const styles = {
    largeIcon: {
      width: 300,
      height: 300,
    },
  };

  let settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    swipe: false,
    //slickGoTo: 4,
  };

  return (
    <Modal
      modalClassName='modalSpecialist'
      isOpen={open}
      toggle={onClose}
      id='exampleModalCenter'
      size='lg'
      centered
    >
      <div>
        <div className={classes.root}>
          <Slider ref={ref} {...settings}>
            <div className='modalSpecialist__form'>
              <ModalHeader toggle={onClose}>
                <h1 className='modalSpecialist__title'>Welcome to Medfix!</h1>
                <h2 className='modalSpecialist__des'>
                  Just a few basic questions to set up right
                </h2>
              </ModalHeader>
              <ModalBody className='modalSpecialist__content'>
                <Row>
                  <Col md={6}>
                    <CssTextField
                      id='standard-full-width'
                      label='Full name'
                      id='fullname'
                      name='fullname'
                      fullWidth
                      margin='normal'
                      required
                      value={fullname.value}
                      onChange={(e) =>
                        setFullname({ ...fullname, value: e.target.value })
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {!fullname.isValid && (
                      <span className='help-block'>Name is Required</span>
                    )}
                  </Col>
                  <Col md={6}>
                    <CssTextField
                      id='gender'
                      name='gender'
                      select
                      required
                      label='Gender'
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={gender.value}
                      fullWidth
                      id='standard-required-gender'
                      onChange={(e) =>
                        setGender({ ...gender, value: e.target.value })
                      }
                    >
                      <MenuItem key='male' value='male'>
                        Male
                      </MenuItem>
                      <MenuItem key='female' value='female'>
                        Female
                      </MenuItem>
                    </CssTextField>
                    {!gender.isValid && (
                      <span className='help-block'>Gender is required</span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <CssTextField
                        id='countrycode'
                        name='countrycode'
                        select
                        label='Country Code'
                        style={{ marginRight: "20px" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={countryCode.value}
                        fullWidth
                        onChange={(e) => {
                          setCountryCode({
                            ...countryCode,
                            value: e.target.value,
                          });
                        }}
                      >
                        <MenuItem key='usa' value='usa'>
                          USA
                        </MenuItem>
                        <MenuItem key='jp' value='jp'>
                          JP
                        </MenuItem>
                      </CssTextField>

                      <CssTextField
                        label='Mobile Number'
                        id='mobile'
                        name='mobile'
                        fullWidth
                        margin='normal'
                        value={mobile.value}
                        onChange={(e) => {
                          setMobile({ ...mobile, value: e.target.value });
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </div>
                    {(!countryCode.isValid || !mobile.isValid) && (
                      <span className='help-block'>
                        Country code and Mobile is required
                      </span>
                    )}
                  </Col>
                  <Col md={6}>
                    <CssTextField
                      id='language'
                      name='language'
                      select
                      required
                      label='Languages Spoken'
                      helperText='Select a maximum of 3 languages'
                      value={languages.value}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      onChange={(e) => {
                        setLanguages({ ...languages, value: e.target.value });
                      }}
                    >
                      <MenuItem key='usa' value='usa'>
                        USA
                      </MenuItem>
                      <MenuItem key='vn' value='vn'>
                        VN
                      </MenuItem>
                    </CssTextField>
                    {!languages.isValid && (
                      <span className='help-block'>Please provide at least one Language</span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <CssTextField
                      label='Medical Board Registration or License no'
                      id='medical-board'
                      name='medical-board'
                      fullWidth
                      required
                      margin='normal'
                      value={license.value}
                      onChange={(e) => {
                        setLicense({ ...license, value: e.target.value });
                      }}
                      helperText='Enter medical License Number'
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {!license.isValid && (
                      <span className='help-block'>License is required</span>
                    )}
                  </Col>
                  <Col md={6}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <CssTextField
                        id='experience'
                        name='experience'
                        select
                        style={{ marginRight: "20px" }}
                        label='Years of Experience'
                        value={month.value}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        helperText='Years of experience in your specialty field'
                        fullWidth
                        onChange={(e) =>
                          setMonth({ ...month, value: e.target.value })
                        }
                      >
                        <MenuItem key='09' value='09'>
                          09
                        </MenuItem>
                        <MenuItem key='08' value='08'>
                          08
                        </MenuItem>
                      </CssTextField>
                      <CssTextField
                        id=''
                        name=''
                        label=' '
                        select
                        value={year.value}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                        onChange={(e) => {
                          setYear({ ...year, value: e.target.value });
                        }}
                      >
                        <MenuItem key='2020' value='2020'>
                          2020
                        </MenuItem>
                        <MenuItem key='2019' value='2019'>
                          2019
                        </MenuItem>
                      </CssTextField>
                    </div>
                    {(!year.isValid || !month.isValid) && (
                      <span className='help-block'>Experience is required</span>
                    )}
                  </Col>
                </Row>
              </ModalBody>
              <div className='modalSpecialist__btn'>
                <button className='btn--bluelight' onClick={() => nextSlice(1)}>
                  Continue
                </button>
              </div>
            </div>
            <div className='modalSpecialist__form'>
              <ModalHeader toggle={onClose}>
                <h2 className='modalSpecialist__text'>
                  Provide your primary consultation address
                </h2>
              </ModalHeader>
              <ModalBody className='modalSpecialist__content'>
                <Row>
                  <Col md={6}>
                    <CssTextField
                      label='Zip/ Postal Code'
                      id='zipcode'
                      name='zipcode'
                      fullWidth
                      margin='normal'
                      value={zipCode.value}
                      onChange={(e) => {
                        setZipCode({ ...zipCode, value: e.target.value });
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {!zipCode.isValid && (
                      <span className='help-block'>Zip Code is require</span>
                    )}
                  </Col>
                  <Col md={6}>
                    <CssTextField
                      label='Country'
                      id='country'
                      name='country'
                      fullWidth
                      margin='normal'
                      value={countryName.value}
                      onChange={(e) => {
                        setCountryName({
                          ...countryName,
                          value: e.target.value,
                        });
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {!countryName.isValid && (
                      <span className='help-block'>
                        Country Name is require
                      </span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <CssTextField
                      label='City'
                      id='city'
                      name='city'
                      fullWidth
                      margin='normal'
                      value={city.value}
                      onChange={(e) => {
                        setCity({ ...city, value: e.target.value });
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {!city.isValid && (
                      <span className='help-block'>City is require</span>
                    )}
                  </Col>
                  <Col md={6}>
                    <CssTextField
                      label='State'
                      id='state'
                      name='state'
                      fullWidth
                      margin='normal'
                      value={status.value}
                      onChange={(e) => {
                        setStatus({ ...status, value: e.target.value });
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {!status.isValid && (
                      <span className='help-block'>Status is require</span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <CssTextField
                      label='Address'
                      id='address'
                      name='address'
                      fullWidth
                      margin='normal'
                      value={address.value}
                      onChange={(e) => {
                        setAddress({ ...address, value: e.target.value });
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {!address.isValid && (
                      <span className='help-block'>Address is require</span>
                    )}
                  </Col>
                </Row>
              </ModalBody>
              <div className='modalSpecialist__btn'>
                <button className='btn--bluelight' onClick={() => nextSlice(2)}>
                  Continue
                </button>
              </div>
            </div>
            <div className='modalSpecialist__form'>
              <ModalHeader toggle={onClose}>
                <h2 className='modalSpecialist__text'>
                  Provide your educational summary
                </h2>
              </ModalHeader>
              <ModalBody className='modalSpecialist__content'>
                {education.map((item, index) => (
                  <CardEdu
                    key={index}
                    item={item}
                    index={index}
                    education={education}
                    addEducation={addEducation}
                    deleteEducation={deleteEducation}
                    setspecialistInfo={setspecialistInfo}
                  />
                ))}
              </ModalBody>
              <div className='modalSpecialist__btn'>
                <button className='btn--bluelight' onClick={() => nextSlice(3)}>
                  Continue
                </button>
              </div>
            </div>
            <div className='modalSpecialist__form'>
              <ModalHeader toggle={onClose}>
                <h2 className='modalSpecialist__text'>
                  Provide your specialty, subspecialty and area(s) of expertise
                </h2>
              </ModalHeader>
              <ModalBody className='modalSpecialist__content'>
                <Row>
                  <Col>
                    <CssTextField
                      label='Specialization'
                      select
                      required
                      id='specialization'
                      name='specialization'
                      helperText='Choose your medical specialty'
                      value={specialization.value}
                      onChange={(e) => {
                        setSpecialization({
                          ...specialization,
                          value: e.target.value,
                        });
                      }}
                      fullWidth
                      margin='normal'
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      <MenuItem key='option1' value='option1'>
                        Option 1
                      </MenuItem>
                      <MenuItem key='option2' value='option2'>
                        Option 2
                      </MenuItem>
                    </CssTextField>
                    {!specialization.isValid && (
                      <span className='help-block'>
                        Specialization is required
                      </span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <CssTextField
                      label='Subspecialty'
                      helperText='Enter subspecialties separated by commas'
                      id='subspecialty'
                      name='subspecialty'
                      value={subspecialty.value}
                      onChange={(e) => {
                        setSubspecialty({
                          ...subspecialty,
                          value: e.target.value,
                        });
                      }}
                      fullWidth
                      required
                      margin='normal'
                    />
                    {!subspecialty.isValid && (
                      <span className='help-block'>
                        Subspecialty is required
                      </span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <CssTextField
                      select
                      label='Conditions or Procedures'
                      helperText='Select conditions you treat and procedures you perform'
                      id='condition'
                      name='condition'
                      value={conditions.value}
                      onChange={(e) => {
                        setConditions({ ...conditions, value: e.target.value });
                      }}
                      fullWidth
                      margin='normal'
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      <MenuItem key='option1' value='option1'>
                        Option 1
                      </MenuItem>
                      <MenuItem key='option2' value='option2'>
                        Option 2
                      </MenuItem>
                    </CssTextField>
                    {!conditions.isValid && (
                      <span className='help-block'>Conditions is required</span>
                    )}
                  </Col>
                </Row>
              </ModalBody>
              <div className='modalSpecialist__btn'>
                <button className='btn--bluelight' onClick={() => nextSlice(4)}>
                  Continue
                </button>
              </div>
            </div>
            <div className='modalSpecialist__form'>
              <ModalBody className='modalSpecialist__contentFinal'>
                <div className='modalSpecialist__icon'>
                  <img style={{ width: "100%" }} src={ImgCheck} />
                </div>
                <div className='modalSpecialist__textFinal'>
                  <h3 className='modalSpecialist__finalTitle'>
                    You're all set
                  </h3>
                  <p className='modalSpecialist__finalDes'>
                    Thank for completing your profile. Explore all account
                    features once your medical registration is verified. For
                    full account access with video consultion,{" "}
                    <a className='modalSpecialist__link' href='#'>
                      click here
                    </a>
                  </p>
                </div>
              </ModalBody>
              <div className='modalSpecialist__btn'>
                <button
                  className='btn--bluelight'
                  onClick={(e) => handleSubmit(e)}
                >
                  GO
                </button>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </Modal>
  );
}
PopupSpecilist.propTypes = PropsType;

export default PopupSpecilist;
